document.addEventListener('DOMContentLoaded', function () {

  var blogCardEl = document.querySelector('.index-blog-card-swiper');
  if (blogCardEl && typeof Swiper !== 'undefined') {
    new Swiper('.index-blog-card-swiper', {
      slidesPerView: 1.25,
      spaceBetween: 15,
      loop: true,
      pagination: { el: '.swiper-pagination', clickable: true },
      simulateTouch: true,
      grabCursor: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        10:   { slidesPerView: 1.25 },
        768:  { slidesPerView: 2 },
        992:  { slidesPerView: 2 },
        1024: { slidesPerView: 3 }
      }
    });
  }

  var meetOurSlider = document.querySelector('.cons_meet_our_slider > .group-block-content');
  if (meetOurSlider && typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
    (function ($) {
      var $thumbSliderBG = $('<div class="thumb-slider-bg"></div>');
      var $thumbSlider   = $('<div class="thumb-slider"></div>');
      $thumbSliderBG.append($thumbSlider);
      $('.cons_meet_our_slider > .group-block-content').after($thumbSliderBG);

      $('.cons_meet_our_slider > .group-block-content .cons_meet_our_slide_img_main').each(function () {
        var src = $(this).find('img').first().attr('src');
        if (src) {
          $thumbSlider.append('<div><span><img src="' + src + '" /></span></div>');
        }
      });

      $('.cons_meet_our_slider > .group-block-content').slick({
        slidesToShow:   1,
        slidesToScroll: 1,
        arrows:         true,
        fade:           true,
        asNavFor:       '.thumb-slider',
        responsive: [{
          breakpoint: 749,
          settings: {
            slidesToShow:   1,
            slidesToScroll: 1,
            infinite:       true,
            dots:           false,
            fade:           false,
            centerMode:     false
          }
        }]
      });

      $('.thumb-slider').slick({
        slidesToShow:   3,
        slidesToScroll: 1,
        asNavFor:       '.cons_meet_our_slider > .group-block-content',
        focusOnSelect:  true,
        centerMode:     false,
        dots:           false,
        arrows:         false
      });
    })(jQuery);
  }

  var menuLinks = document.querySelectorAll('.menu-list__list-item a');
  var currentPath = window.location.pathname;
  menuLinks.forEach(function (link) {
    if (link.getAttribute('href') === currentPath) {
      link.parentElement.classList.add('highlight_menu');
    }
  });

  document.querySelectorAll('.custom-filter').forEach(function (button) {
    button.addEventListener('click', function () {
      var activeEl = document.querySelector('.icon-checkmark-active');
      sessionStorage.setItem('scrollTo', activeEl ? 'active' : String(window.scrollY));
    });
  });

  var scrollTo = sessionStorage.getItem('scrollTo');
  if (scrollTo === 'active') {
    var activeEl = document.querySelector('.icon-checkmark-active');
    if (activeEl) activeEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  } else if (scrollTo) {
    window.scrollTo({ top: parseInt(scrollTo, 10), behavior: 'smooth' });
  }
  sessionStorage.removeItem('scrollTo');

  var benefitItems = document.querySelectorAll('.benefit-item');
  benefitItems.forEach(function (item) {
    item.addEventListener('click', function () {
      benefitItems.forEach(function (i) {
        if (i !== item) i.classList.remove('active');
      });
      item.classList.toggle('active');
    });
  });

});
